let React = require('react');
import GenericSimpleButton from './Com.Gyf.WebCore.GenericSimpleButton';

let GenericModal = React.createClass({

    render: function () {
        let yesButton = null;
        let noButton = null;
        let dismissButton = null;
        let triggerButton = null;
        let screenSize = null;

        let header = null;
        let body = null;
        let footer = null;
        let isCustomized = false;

        if (this.props !== undefined) {
            switch (this.props.type) {
                case 'DISCARD_CHANGES_CANCEL':
                    triggerButton = <GenericSimpleButton text="Descartar" buttonClass="btn btn-primary btn-cta" dataDismiss={"modal"}
                        onClick={this.props.onClick} />;
                    dismissButton = <GenericSimpleButton text="Cancelar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />;
                    header = <h2 className="modal-title" id="myModalLabel">Atenci&oacute;n</h2>;
                    body = this.props.body;
                    screenSize = "modal-dialog modal-generic";
                    break;
                case 'DELETE_CANCEL':
                    triggerButton = <GenericSimpleButton text="Eliminar" buttonClass="btn btn-primary btn-cta" onClick={this.props.onClick} />;
                    dismissButton = <GenericSimpleButton text="Cancelar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />;
                    header = <h2 className="modal-title" id="myModalLabel">{this.props.header}</h2>;
                    body = this.props.body;
                    screenSize = "modal-dialog modal-generic";
                    break;
                case 'ALL_CUSTOM': {
                    isCustomized = true;
                    header = <div className="modal-header">
                        <div className="close" data-dismiss="modal" aria-hidden="true">
                            <label className="ti-close clickable"></label>
                        </div>
                        {this.props.header}
                    </div>
                    body = <div className="modal-body">{this.props.body}</div>
                    footer = <div className="modal-footer">{this.props.footer}</div>
                    screenSize = this.props.screenSize;
                    break;
                }

                //case 'YES_NO':
                //    yesButton = <GenericSimpleButton text="Si" buttonClass="btn btn-primary btn-cta" onClick={this.props.yesMethod} />;
                //    noButton = <GenericSimpleButton text="No" buttonClass="btn btn-default btn-secondary" onClick={this.props.noMethod} />;
                //    header = <h4 className="modal-title" id="myModalLabel">{this.props.header}</h4>;
                //    body = <p>{this.props.body}</p>;
                //    screenSize = "modal-dialog";
                //    break;
                //case 'OK_CANCEL':
                //    triggerButton = <GenericSimpleButton text="Ok" buttonClass="btn btn-primary btn-cta" onClick={this.props.onClick} />;
                //    dismissButton = <GenericSimpleButton text="Cancelar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />;
                //    header = <h4 className="modal-title" id="myModalLabel">{this.props.header}</h4>;
                //    body = <p>{this.props.body}</p>;
                //    screenSize = "modal-dialog";
                //    break;
                //case 'WARNING':
                //    dismissButton = <GenericSimpleButton text="Ok" dataDismiss={"modal"} buttonClass="btn btn-primary btn-cta" />;
                //    header = <h4 className="modal-title" id="myModalLabel">{this.props.header}</h4>;
                //    body = <p>{this.props.body}</p>;
                //    screenSize = "modal-dialog";
                //    break;
                //case 'ERROR':
                //    dismissButton = <GenericSimpleButton text="Ok" dataDismiss={"modal"} buttonClass="btn btn-primary btn-cta" />;
                //    header = <h4 className="modal-title" id="myModalLabel">{this.props.header}</h4>;
                //    body = <p>{this.props.body}</p>;
                //    screenSize = "modal-dialog";
                //    break;
                //case 'DISCARD_CHANGES_ACCEPT':
                //    triggerButton = <GenericSimpleButton text="Descartar" buttonClass="btn btn-primary btn-cta" dataDismiss={"modal"}
                //        onClick={this.props.onClick} />;
                //    dismissButton = <GenericSimpleButton text="Aceptar" dataDismiss={"modal"} buttonClass="btn btn-default btn-secondary" />;
                //    header = <h4 className="modal-title" id="myModalLabel">Atenci&oacute;n</h4>;
                //    body = <p>{this.props.body}</p>;
                //    screenSize = "modal-dialog";
                //    break;
                //case 'WITH_COMPONENTS':
                //    header = <h2 className="modal-title" id="myModalLabel">{this.props.header}</h2>;
                //    body = this.props.component;
                //    screenSize = "modal-dialog modal-generic";
                //    break;
                //case 'WITH_COMPONENTS_FOOTER_BUTTONS':
                //    triggerButton = <GenericSimpleButton text={this.props.confirmButtonText} buttonClass="btn btn-primary btn-cta" onClick={this.props.onClick} />;
                //    dismissButton = <GenericSimpleButton text="Cancelar" dataDismiss="modal" buttonClass="btn btn-default btn-secondary" />;
                //    header = <h2 className="modal-title">{this.props.header}</h2>;
                //    body = this.props.component;
                //    screenSize = "modal-dialog modal-md";
                //    break;

                default:
                    break;
            }
        }
        return (
            <div className={this.props.className} id={this.props.id} role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className={screenSize}>
                    {(isCustomized == false) ?
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="close" data-dismiss="modal" aria-hidden="true">
                                    <label className="ti-close clickable"></label>
                                </div>
                                {header}
                            </div>

                            <div className="modal-body">
                                {body}
                            </div>

                            <div className="modal-footer">
                                <div className="row">
                                    <div className="col-xs-4">
                                        {triggerButton}
                                    </div>
                                    <div className="col-xs-8">
                                        {dismissButton}
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className="modal-content">
                            {header}
                            {body}
                            {footer}
                        </div>}
                </div>
            </div >
        );
    }
});
export default GenericModal;